// extracted by mini-css-extract-plugin
export var dataCell = "_s2-2";
export var dataRow = "_s2-0";
export var headerRow = "_s2-1";